import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Alert, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';


import * as FicheActions from 'redux/modules/fiches';
import * as ProductActions from 'redux/modules/products';

import _ from 'underscore';
import { analyseState } from 'utils/analyseState';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
	state => ({
		smsActions: state.products.smsActions,
		user: state.auth.user,
		from: state.products.from,
		site_state: state.products.site_state,
		mcpCalled: state.products.mcpCalled
	}),
	dispatch => bindActionCreators({ ...ProductActions, ...FicheActions }, dispatch)
)

export default class ModifyIDPTU extends Component {

	constructor(props) {
		super(props);

		this.intervalNumber = 0;

		this.state = {
			success: false,
			error: false,
		};

		this.hasReloaded = false;
		this.modifyIDPTU = this.modifyIDPTU.bind(this);
		this.reloadFiche = this.reloadFiche.bind(this);

	}


	componentDidMount() {

		var self = this;
		// Le polling n'est plus nécessaire - le WebSocket notifie directement les changements d'état
	}

	componentWillUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	reloadFiche() {
		var self = this;
		this.setState({ error: false, success: false })
		//setTimeout(()=> self.props.loadProduct( self.props.urlParams.productID,  self.props.urlParams), 6000);
		self.props.reloadForm()
		self.props.triggerError('', 'idptu')
	}


	componentDidUpdate(prevProps) {

		var self = this;
		var actions = analyseState(this.props.site_state);

		if (self.props.product) {
			var ficheID = self.props.product.s_id;
		} else {
			var ficheID = self.props.urlParams.ficheID;
		}


		if (this.props.from == 'modifyIDPTU' || this.props.hasCurrentIDPTUModif) {
			var action = actions.asts1;
			var smsAction = this.props.smsActions[ficheID] && this.props.smsActions[ficheID]['asts1'];

			if (smsAction) {
				var stateChanged = prevProps.site_state !== this.props.site_state;
				var actionInProgress = smsAction.smsSent == true || this.props.hasCurrentIDPTUModif;

				if (stateChanged && actionInProgress && !this.state.success && !this.state.error) {
					if (action.state == 3) {
						this.props.endInterval(action.type, ficheID);
						this.setState({ success: true });
						try {
							this.props.handleOpenModal(<span>{this.props.t('modifyIDPTU.valid_number')} <i className="text-success fa fa-check" aria-hidden="true"></i></span>);
						} catch(e) {}
					} else if (action.state > 3) {
						this.props.endInterval(action.type, ficheID);
						this.hasReloaded = true;
						this.setState({ error: action.stateLabel });
						try {
							this.props.handleOpenModal(<span>{this.props.t('modifyIDPTU.invalid_number')}: {action.stateLabel} <i className="text-danger fa fa-times" aria-hidden="true"></i></span>);
						} catch(e) {}
						this.reloadFiche();
					}
				}

				if (smsAction.intervalFinished == true && !this.hasReloaded && !this.state.error) {
					this.hasReloaded = true;
					this.reloadFiche();
				}
			}
		}
	}

	modifyIDPTU() {

		var self = this;
		const {t} = self.props

		var user = this.props.user;
		if (user.role == 'admin') {
			var userId = this.props.urlParams.cid;
		} else {
			var userId = user.name;
		}

		var actionLabel = t("modifyIDPTU.idptu_modification")

		var payload = { type: 'asts1', user: userId };

		if (this.props.product) {
			this.props.site.id = this.props.product.s_id
		}

		this.props.modifyIDPTU(
			this.props.site.id,
			this.props.product.id,
			this.props.IDPTU,
			this.props.PIDPTU,
			userId,
			this.props.urlParams).then(() => {
				this.props.sendSMS(
					self.props.site,
					payload,
					self.props.urlParams,
					'asts1',
					self.props.state,
					actionLabel, "modifyIDPTU")
			})
	}


	render() {

		const {t} = this.props
		var tooltip = <Tooltip id="tooltip">
			<strong>
				{t("modifyIDPTU.call_to_verify")} 		
			</strong>
		</Tooltip>

		var otr =
			(<OverlayTrigger placement="top" overlay={tooltip}>
				<i className="fa fa-info-circle"></i>
			</OverlayTrigger>);

		var intervalLaunched = false;
		var error = false;

		var already_requested = false;

		if (this.props.site.id in this.props.smsActions) {
			if (this.props.smsActions[this.props.site.id].asts1) {
				intervalLaunched = this.props.smsActions[this.props.site.id].asts1.intervalLaunched;
				error = this.props.smsActions[this.props.site.id].asts1.error
			}
		}

		if (this.props.hasCurrentIDPTUModif) {
			already_requested = true
		}


		return (
			<span>
				{(!this.state.error && !this.state.success) &&
					<div>
						<Button style={{ display: 'inline', margin: '-13px 0 0 -15px' }}
							disabled={(intervalLaunched && this.props.from == 'modifyIDPTU') || already_requested || this.props.id_dup} bsStyle="danger" onClick={this.modifyIDPTU}>
							<div>
								{ t("modifyIDPTU.idptu_modification") } {otr} &nbsp;
								{((intervalLaunched && this.props.from == 'modifyIDPTU')) &&
									<i className="fa fa-cog fa-spin fa-1x fa-fw"></i>
								}
							</div>

						</Button>
						<br />
					</div>
				}

				{/*error &&
					<Alert bsStyle="danger">{error}</Alert>
				*/}

				{this.state.success &&
					<Alert bsStyle="success" style={{ margin: '0 0 0 -15px' }}>
						{ t("modifyIDPTU.valid_number") }
					</Alert>
				}

				{this.state.error != false &&
					<Alert bsStyle="danger" style={{ margin: '0 0 0 -15px' }}>
						{t("modifyIDPTU.invalid_number")}
						<Button bsStyle="primary" type="button" onClick={this.reloadFiche}>
							{t("modifyIDPTU.reload_sheet")}
						</Button>
					</Alert>
				}


			</span>


		);



	}
}

